import Kanri from './KanriApp.vue';
import kanriMenu from './templates/KanriMenu.vue';
import organizationMenu from './templates/OrganizationMenu.vue';
import organizationInfo from './templates/OrganizationInfo.vue';
import organizationSearch from './templates/OrganizationSearch.vue';
import userMenu from './templates/UserMenu.vue';
import userInfo from './templates/UserInfo.vue';
import userSearch from './templates/UserSearch.vue';
import userChangePassword from './templates/UserChangePassword.vue';
import masterCodeMenu from './templates/MasterCodeMenu.vue';
import masterCodeTableInfo from './templates/MasterCodeTableInfo.vue';
import masterCodeTableSearch from './templates/MasterCodeTableSearch.vue';
//import masterCodeInfo from './templates/MasterCodeInfo.vue';
import masterCodeSearch from './templates/MasterCodeSearch.vue';
import mailTemplateInfo from './templates/MailTemplateInfo.vue';  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add
import mailScheduleSearch from './templates/MailScheduleSearch.vue';  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add
import mailScheduleInfo from './templates/MailScheduleInfo.vue';  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add
import mailScheduleContentInfo from './templates/MailScheduleContentInfo.vue';  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add


export default {
  path: '/kanri',
  component: Kanri,
  children: [
    {
      name: 'kanri-top',
      path: '/',
      component: kanriMenu,
    },
    {
      name: 'organizationMenu',
      path: 'organization',
      component: organizationMenu,
    },
    {
      name: 'organizationInfo',
      path: 'organization/info',
      component: organizationInfo,
    },
    {
      name: 'organizationSearch',
      path: 'organization/search',
      component: organizationSearch,
    },
    {
      name: 'userMenu',
      path: 'user',
      component: userMenu,
    },
    {
      name: 'userInfo',
      path: 'user/info',
      component: userInfo,
    },
    {
      name: 'userChangePassword',
      path: 'user/info/password',
      component: userChangePassword,
    },
    {
      name: 'userSearch',
      path: 'user/search',
      component: userSearch,
    },
    {
      name: 'masterCodeMenu',
      path: 'masterCode',
      component: masterCodeMenu,
    },
    {
      name: 'masterCodeTableInfo',
      path: 'masterCodeTable/info',
      component: masterCodeTableInfo,
    },
    {
      name: 'masterCodeTableSearch',
      path: 'masterCodeTable/search',
      component: masterCodeTableSearch,
    },
    // {
    //   name: 'masterCodeInfo',
    //   path: 'masterCode/info',
    //   component: masterCodeInfo,
    // },
    {
      name: 'masterCodeSearch',
      path: 'masterCode/search',
      component: masterCodeSearch,
    },
    // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add start
    {
      name: 'mailTemplateInfo',
      path: 'mailTemplate/info',
      component: mailTemplateInfo,
    },
    {
      name: 'mailScheduleSearch',
      path: 'mailSchedule/search',
      component: mailScheduleSearch,
    },
    {
      name: 'mailScheduleInfo',
      path: 'mailSchedule/info',
      component: mailScheduleInfo,
    },
    {
      name: 'mailScheduleContentInfo',
      path: 'mailSchedule/info/content',
      component: mailScheduleContentInfo,
    },
    // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add end
  ],
};
